import React from "react";
import Button from "../../elements/Button/Button";
import {useTranslation} from "react-i18next";

import "./CampaignsPage.scss";

const CampaignOverviewElement = (props) => {
  const { t } = useTranslation();

  const target = props.targets.find(item => item.id === props.campaign.target_id);
  return (
   <div className={'campaign-overview__element'}>
     <div>
      {props.campaign.display_name}&nbsp;-&nbsp;
       {target && target.display_name}
     </div>
     <div>
       <Button
         type="button"
         size="large"
         variant="contained"
         color="primary"
         onClick={() => props.onRename(props.campaign.hash, props.campaign.display_name)}
       >
         {t("CampaignOverview.RenameButton")}
       </Button>
       <Button
         type="button"
         size="large"
         variant="contained"
         color="primary"
         onClick={() => props.onRemove(props.campaign.hash)}
       >
         {t("CampaignOverview.RemoveButton")}
       </Button>
       <Button
         type="button"
         size="large"
         variant="contained"
         color="primary"
         onClick={() => props.onDetails(props.campaign.hash)}
       >
         {t("CampaignOverview.DetailsButton")}
       </Button>
     </div>
   </div>
  );
}

export default CampaignOverviewElement;